import EventsResource from "./events.resource";

const eventsModule = angular
  .module("app.resources.events", [])
  .service("MarketingEvents", EventsResource);

export default eventsModule;



// WEBPACK FOOTER //
// ./src/resources/events/events.module.js